import React, { useState } from 'react';
import { NavLink, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLoginUserType } from '../../store/slices/commonSlice';

const SidebarMenu = ({
  to,
  icon,
  title,
  toggle,
  className,
  isActive,
  suffix,
  suffixColor,
  collapisble = false,
  subItems = []
}) => {
  const { t } = useTranslation();
  const loginUserType = useLoginUserType();
  const [isOpen, setIsOpen] = useState(false);

  return collapisble ? (
    <NavItem
      className={`${className} position-relative nav-title`}
      style={{ cursor: 'pointer' }}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}>
      <b className={`left-curve ${isActive ? 'd-block' : ''}`}></b>
      <b className={`right-curve ${isActive ? 'd-block' : ''}`}></b>
      <div className="gap-2 d-flex align-items-center px-3 mt-1 nav-link position-relative">
        <span
          className={`sidebarIcon d-flex align-items-center ${isActive ? 'text-primary' : 'text-white'}`}>
          {icon}
        </span>
        <div
          className={`d-flex flex-grow-1 align-items-center gap-2 ${isActive ? 'text-primary fw-bold' : 'text-white'}`}>
          <span>{title}</span>
          <i className="bi bi-chevron-down" />
        </div>
        <div
          className="sub-item-dropdown shadow-sm"
          style={{
            left: subItems?.length < 3 ? '-10%' : '-100%',
            opacity: isOpen ? 1 : 0,
            pointerEvents: isOpen ? 'auto' : 'none'
          }}>
          {subItems.map((val, index) => {
            return val.subItems.length > 0 ? (
              <div key={index} className="sub-items">
                <div className="gap-2 d-flex align-items-center px-4 mt-1 nav-link">
                  <div
                    className={`d-flex flex-grow-1 align-items-center gap-2 text-white sub-main-title`}>
                    <span>{loginUserType === 'agent' ? t(val.i18nTitle) : val.title}</span>
                  </div>
                </div>
                {val.subItems.map((subVal, subIndex) => {
                  return (
                    <NavLink
                      key={subIndex}
                      tag={Link}
                      to={subVal.href}
                      onClick={() => setIsOpen(false)}
                      className="gap-2 d-flex align-items-center px-4">
                      <div
                        className={`d-flex flex-grow-1 align-items-center gap-2 ${window.location.pathname === subVal.href ? 'text-white fw-bold' : 'text-lightGray'}`}>
                        <span>
                          {loginUserType === 'agent' ? t(subVal.i18nTitle) : subVal.title}
                        </span>
                      </div>
                    </NavLink>
                  );
                })}
              </div>
            ) : (
              <NavLink
                key={index}
                tag={Link}
                to={val.href}
                onClick={() => setIsOpen(false)}
                className={`gap-2 d-flex align-items-center px-4 mt-1 ${window.location.pathname === val.href ? 'bg-white' : ''}`}>
                <span
                  className={`sidebarIcon d-flex align-items-center ${window.location.pathname === val.href ? 'text-primary' : 'text-white'}`}></span>
                <div
                  className={`d-flex flex-grow-1 align-items-center gap-2 ${window.location.pathname === val.href ? 'text-primary fw-bold' : 'text-white'}`}>
                  <span>{loginUserType === 'agent' ? t(val.i18nTitle) : val.title}</span>
                </div>
              </NavLink>
            );
          })}
        </div>
      </div>
    </NavItem>
  ) : (
    <NavItem className={`${className} position-relative`}>
      <b className={`left-curve ${isActive ? 'd-block' : ''}`}></b>
      <b className={`right-curve ${isActive ? 'd-block' : ''}`}></b>
      <NavLink tag={Link} to={to} className="gap-2 d-flex align-items-center px-3 mt-1">
        <span
          className={`sidebarIcon d-flex align-items-center ${isActive ? 'text-primary' : 'text-white'}`}>
          {icon}
        </span>
        <div
          className={`d-flex flex-grow-1 align-items-center gap-2 ${isActive ? 'text-primary fw-bold' : 'text-white'}`}>
          <span>{title}</span>
          {suffix ? <label className="bg-info rounded-circle msg-badge">{suffix}</label> : ''}
        </div>
      </NavLink>
    </NavItem>
  );
};
SidebarMenu.propTypes = {
  title: PropTypes.string,
  isActive: PropTypes.bool,
  to: PropTypes.string,
  icon: PropTypes.node,
  toggle: PropTypes.func,
  className: PropTypes.string,
  suffix: PropTypes.any,
  suffixColor: PropTypes.string,
  collapisble: PropTypes.bool,
  subItems: PropTypes.arrayOf(PropTypes.object)
};

export default SidebarMenu;
